import React from 'react'
import { IconProp } from '@fortawesome/fontawesome'
import { faCheckCircle, faExclamationTriangle, faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Body, Text } from 'uiComponents/typography'
import { DiscountPoolUpload } from 'discounts/types'
import { t } from 'translations'

interface CodeStatusProps {
    status: DiscountPoolUpload['status']
}

interface CodeOptions {
    icon: IconProp
    status: 'success' | 'error' | 'processing'
}

const CODE_STATE: Record<DiscountPoolUpload['status'], CodeOptions> = {
    completed: {
        icon: faCheckCircle as IconProp,
        status: 'success',
    },
    deleted: {
        icon: faExclamationTriangle as IconProp,
        status: 'processing',
    },
    error: {
        icon: faExclamationTriangle as IconProp,
        status: 'error',
    },
    expired: {
        icon: faExclamationTriangle as IconProp,
        status: 'error',
    },
    redeemed: {
        icon: faCheckCircle as IconProp,
        status: 'success',
    },
    valid: {
        icon: faCheckCircle as IconProp,
        status: 'success',
    },
    pending: {
        icon: faSpinner as IconProp,
        status: 'processing',
    },
}

const getCodeState = (status: DiscountPoolUpload['status']) => {
    const codeState = CODE_STATE[status]

    return (
        codeState || {
            icon: faExclamationTriangle as IconProp,
            status: 'processing',
        }
    )
}

const getCodeStateLabel = (status: DiscountPoolUpload['status']) => {
    switch (status) {
        case 'completed':
            return t('discounts.shared.status.completed')
        case 'deleted':
            return t('discounts.shared.status.deleted')
        case 'error':
            return t('discounts.shared.status.error')
        case 'expired':
            return t('discounts.shared.status.expired')
        case 'redeemed':
            return t('discounts.shared.status.redeemed')
        case 'valid':
            return t('discounts.shared.status.valid')
        case 'pending':
            return t('discounts.shared.status.pending')
        default:
            return t('discounts.shared.status.unknown')
    }
}

export const CodeStatus: React.FC<CodeStatusProps> = ({ status }) => {
    const state = getCodeState(status)

    return (
        <Body size={1}>
            <Text status={state.status}>
                <FontAwesomeIcon icon={state.icon} style={{ marginRight: '.5rem' }} />
                {getCodeStateLabel(status)}
            </Text>
        </Body>
    )
}
